import { MenuItem } from "@/app/lib/features/menus/menus.types";
import Link from "next/link";
import { FC } from "react";
import { trackInteraction } from "@/app/lib/tracking/interactions";

interface SubCategoriesButtonProps {
  category: MenuItem;
  onClose?: () => void;
}

const SubCategoriesButton: FC<SubCategoriesButtonProps> = ({ category, onClose }) => {
  return (
    <Link
      href={`/${category.url}`}
      onClick={() => { trackInteraction("menu", category.id, "click"); onClose?.(); }}
      className="flex group/subCategories items-center gap-3"
    >
      <p className="text-lg font-semibold text-main group-hover/subCategories:underline">
        {category.name}
      </p>
    </Link>
  );
};

export default SubCategoriesButton;
